var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivered = function SvgDelivered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    viewBox: "0.71 0.43 17.14 17.14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.286 1v4.923m-8 0h16v9.846a1.23 1.23 0 0 1-1.231 1.23H2.516a1.23 1.23 0 0 1-1.23-1.23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.286 5.923 1.846-3.557A2.46 2.46 0 0 1 5.273 1h8.025a2.46 2.46 0 0 1 2.203 1.366l1.785 3.557M12.362 9l-3.688 4.923-2.461-1.844"
  })));
};
export default SvgDelivered;